/** @jsx jsx */

import { IRecord } from "../../types/schema"
import { createSelectField } from "../../componentFactories/_createSelectField"
import { buildSearchFilter } from "../../utils/buildSearchFilter"

type CompanyForSelect = IRecord<"companies", "name">

export const NewCompanySelectField = createSelectField({
  model: "companies",
  attributes: ["name"],
  queryToSkeemFilter(query: string) {
    return buildSearchFilter(["name"], query)
  },
  getSkeemSort() {
    return { by: "name", direction: "asc" }
  },
  renderOption(record: CompanyForSelect) {
    return record.name
  },
})
